import { useState, useRef, useEffect } from "react";
import { FiFilter, FiChevronDown, FiX } from "react-icons/fi";

export default function CustomFilterDropdown({
  options = [],
  onChange,
  placeholder = "Filter",
  valueKey = "id",
  labelKey = "name",
  /** Stretch to container width on narrow layouts (e.g. hero grid on mobile) */
  fullWidth = false,
}) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelected(option);
    setOpen(false);
    onChange?.(option[valueKey], option);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setSelected(null);
    onChange?.(null, null);
  };

  const displayText = selected ? selected[labelKey] : placeholder;
  const isActive = Boolean(selected);

  return (
    <div
      className={`relative text-left ${fullWidth ? "block w-full" : "inline-block"}`}
      ref={dropdownRef}
    >
      {/* BUTTON */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`
  flex items-center gap-2
  rounded-lg px-3 py-2.5
  text-sm font-medium
  transition shadow-sm
  ${
    fullWidth
      ? "w-full min-w-0 sm:min-w-[160px]"
      : "min-w-[120px] sm:min-w-[160px]"
  }
  border
  ${
    isActive
      ? "bg-toucanTeal text-white border-toucanTeal"
      : "bg-white text-toucanTeal border-toucanTeal"
  }
  hover:opacity-90
`}
      >
        {isActive ? (
          <FiX
            size={16}
            onClick={handleClear}
            className="cursor-pointer hover:opacity-80"
          />
        ) : (
          <FiFilter size={16} />
        )}

        <span className="flex-1 text-left truncate">{displayText}</span>

        <FiChevronDown
          size={16}
          className={`transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {/* DROPDOWN */}
      {open && (
        <div
          className="
      absolute left-0 top-full mt-2
      w-full min-w-[200px]
      bg-white border border-gray-200
      rounded-lg shadow-xl
      py-2
      max-h-[300px] overflow-y-auto
      z-[9999]
    "
        >
          {options.length > 0 ? (
            options.map((option) => {
              const isSelected = selected?.[valueKey] === option[valueKey];

              return (
                <div
                  key={option[valueKey]}
                  onClick={() => handleSelect(option)}
                  className={`
                    px-4 py-2 text-sm cursor-pointer transition-colors z-50
                    ${
                      isSelected
                        ? "bg-toucanTeal/10 text-toucanTeal font-medium"
                        : "text-gray-700 hover:bg-gray-100"
                    }
                  `}
                >
                  {option[labelKey]}
                </div>
              );
            })
          ) : (
            <div className="px-4 py-2 text-sm text-gray-500">
              No options available
            </div>
          )}
        </div>
      )}
    </div>
  );
}
